<template>
  <div>
    <div style="width:100%;height:100%">
      <h1 class="chart-top-title">原料采购使用<span @click="dialogVisible = true" class="chart-modal-flag"><i class="el-icon-view"></i></span></h1>
      <div
        class="chart-wrapper"
        ref="chart"
        style="height:324px;width:100%"
      ></div>
      <p class="remarkes">备注：2012年～2017年四种主要药品原材料采购金额（千万）</p>
    </div>
    <el-dialog :visible.sync="dialogVisible" :append-to-body="true" :fullscreen="true" center :modal="mask">
      <div class="modalContent">
        <img src="../../../static/imgs/collectingMaterials.jpg" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { vueBus } from '../../assets/js/common/vueBus'
export default {
  name: 'LineChart',
  props: {
    echartsData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      anima:'',
      dataArr: [
        [2447.00, 2854.6, 3289.41, 3638, 4027.64, 4383.19],
        [9177.14, 10705.8, 12336.52, 13643.86, 15105.14, 16438.6],
        [4877.68, 5690.17, 6556.9, 7251.75, 8028.43, 8737.17],
        [7931.89, 9253.13, 10662.58, 11792.52, 13055.52, 14208.04]
      ],
      color: ['#D34D4D', '#e59f38', '#81A566', '#4BADCC'],
      opacityColor:['rgba(211,77,77,.3)','rgba(229,159 ,56,.3)', 'rgba(129,156,102,.3)','rgba(75,173,204,.3)'],
      xData: ['2012','2013', '2014', '2015', '2016', '2017'],
      axisLabelColor: '#ccd6e0',
      axisLineColor: '#809ab1',
      seriesName: ['布洛芬', '麝香', '黄连', '氨茶碱'],
      dialogVisible: false,
      mask: false
    }
  },
  watch: {
    echartsData: {
      handler: function(val, oldVal) {
        this.initChart()
      },
      deep: true //增加deep 观察对象的子对象变化
    },
    anima: {
      handler: function(val, oldVal) {
        if (val == 'animateStart') {
          this.myChart = this.$echarts.init(this.$refs.chart,null,{renderer: 'svg'})
          this.initChart()
        }
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      let me = this
      vueBus.$on('imgOnload', v => {
        me.anima = v
      })
    })
  },
  methods: {
    initChart() {
      let series = []
      this.dataArr.map((item, index) => {
        series.push({
          name: this.seriesName[index],
          type: 'line',
          symbol: 'circle',
          symbolSize: 10,
          lineStyle: {
            normal: {
              width: 2,
              color: this.color[index]
            }
          },
          itemStyle: {
            normal: {
              color: '#fff',
              borderColor: this.color[index],
              borderWidth: 4
            }
          },
          areaStyle: {
            normal: {
              color:this.opacityColor[index]
            }
          },
          data: item
        })
      })
      let option = {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          show: false
        },
        xAxis: [
          {
            
            boundaryGap: false,
            axisLine: {
              lineStyle: {
                color: this.axisLineColor
              }
            },
            axisLabel: {
              color: this.axisLabelColor
            },
            axisTick: { show: false },
            data: this.xData
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '单位：千万',
            nameTextStyle: {
              color: this.axisLabelColor,
              fontSize: 16
            },
            axisLine: {
              lineStyle: {
                color: this.axisLineColor
              }
            },
            axisTick: { show: false },
            axisLabel: {
              margin: 10,
              textStyle: {
                fontSize: 14
              },
              color: this.axisLabelColor
            },
            splitLine: {
              show: false
            }
          }
        ],
        grid: {
          top: 40,
          bottom: 50,
          left: 80,
          right: 50
        },
        series: series,
        animationEasing: 'bounceOut'
      }
      this.myChart.setOption(option)
      window.onresize = this.myChart.resize
      var currentIndex = -1
      let _this = this
      // setInterval(function() {
      //   var dataLen = option.series[0].data.length

      //   // 取消之前高亮的图形
      //   _this.myChart.dispatchAction({
      //     type: 'downplay',
      //     seriesIndex: 0,
      //     dataIndex: currentIndex
      //   })
      //   currentIndex = (currentIndex + 1) % dataLen
      //   // 高亮当前图形
      //   _this.myChart.dispatchAction({
      //     type: 'highlight',
      //     seriesIndex: 0,
      //     dataIndex: currentIndex
      //   })
      //   // 显示 tooltip
      //   _this.myChart.dispatchAction({
      //     type: 'showTip',
      //     seriesIndex: 0,
      //     dataIndex: currentIndex
      //   })
      // }, 1000)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

</style>





// WEBPACK FOOTER //
// src/components/echarts/LineChart.vue